const CACHE_NAME = 'im-image-cache-v1';
const objectUrlMap = new Map();
const pendingMap = new Map();

function canCache(url) {
	return /^https?:\/\//i.test(url || '');
}

async function responseToObjectUrl(response) {
	const blob = await response.blob();
	return URL.createObjectURL(blob);
}

export async function getCachedImageUrl(url) {
	if (!canCache(url) || !window.caches) {
		return url;
	}
	if (objectUrlMap.has(url)) {
		return objectUrlMap.get(url);
	}
	if (pendingMap.has(url)) {
		return pendingMap.get(url);
	}
	const pending = (async () => {
		try {
			const cache = await window.caches.open(CACHE_NAME);
			const cached = await cache.match(url);
			if (cached) {
				const objectUrl = await responseToObjectUrl(cached.clone());
				objectUrlMap.set(url, objectUrl);
				return objectUrl;
			}
			const response = await fetch(url, {
				mode: 'cors',
				cache: 'force-cache'
			});
			if (!response.ok || response.type === 'opaque') {
				return url;
			}
			await cache.put(url, response.clone());
			const objectUrl = await responseToObjectUrl(response);
			objectUrlMap.set(url, objectUrl);
			return objectUrl;
		} catch (error) {
			console.warn('[imageCache] 图片缓存失败，使用原始地址:', url, error);
			return url;
		} finally {
			pendingMap.delete(url);
		}
	})();
	pendingMap.set(url, pending);
	return pending;
}
